import React from "react";
import useInput from "../../hooks/use-input";
import classes from "./BookingForm.module.css";
import TextField from "@mui/material/TextField";

const BookingForm = (props) => {
  const isEmpty = (value) => value.trim() !== "";
  const isAnything = (value) => value.trim() !== "" || value.trim() === "";

  const {
    value: enteredFirstName,
    isValid: firstNameIsValid,
    hasError: firstNameHasError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: firstNameReset,
  } = useInput(isEmpty);

  const {
    value: enteredLastName,
    isValid: lastNameIsValid,
    hasError: lastNameHasError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: lastNameReset,
  } = useInput(isEmpty);

  const {
    value: enteredPhoneNumber,
    isValid: phoneNumberIsValid,
    hasError: phoneNumberHasError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: phoneNumberReset,
  } = useInput(isEmpty);

  const {
    value: enteredDate,
    isValid: dateIsValid,
    hasError: dateHasError,
    valueChangeHandler: dateChangeHandler,
    inputBlurHandler: dateBlurHandler,
    reset: dateReset,
  } = useInput(isEmpty);

  const {
    value: enteredTime,
    isValid: timeIsValid,
    hasError: timeHasError,
    valueChangeHandler: timeChangeHandler,
    inputBlurHandler: timeBlurHandler,
    reset: timeReset,
  } = useInput(isEmpty);

  const {
    value: enteredNumberOfPeople,
    isValid: numberOfPeopleIsValid,
    hasError: numberOfPeopleHasError,
    valueChangeHandler: numberOfPeopleChangeHandler,
    inputBlurHandler: numberOfPeopleBlurHandler,
    reset: numberOfPeopleReset,
  } = useInput(isEmpty);

  const {
    value: enteredNote,
    isValid: noteIsValid,
    hasError: noteHasError,
    valueChangeHandler: noteChangeHandler,
    inputBlurHandler: noteBlurHandler,
    reset: noteReset,
  } = useInput(isAnything);

  const confirmHandler = (event) => {
    event.preventDefault();

    if (
      !firstNameIsValid ||
      !lastNameIsValid ||
      !phoneNumberIsValid ||
      !dateIsValid ||
      !timeIsValid ||
      !numberOfPeopleIsValid ||
      !noteIsValid
    ) {
      return;
    }

    props.onConfirm({
      FullName: enteredFirstName + " " + enteredLastName,
      PhoneNumber: enteredPhoneNumber,
      Date: enteredDate + " " + enteredTime,
      NumberOfPeople: enteredNumberOfPeople,
      Note: enteredNote,
      Token: "y++Dcbbt8tQFdnZyX6BB2g==",
    });

    firstNameReset();
    lastNameReset();
    phoneNumberReset();
    dateReset();
    timeReset();
    numberOfPeopleReset();
    noteReset();
  };

  const firstNameClasses = `${classes.control} ${
    firstNameHasError ? classes.invalid : ""
  }`;
  const lastNameClasses = `${classes.control} ${
    lastNameHasError ? classes.invalid : ""
  }`;
  const phoneNumberClasses = `${classes.control} ${
    phoneNumberHasError ? classes.invalid : ""
  }`;
  const dateClasses = `${classes.control} ${
    dateHasError ? classes.invalid : ""
  }`;
  const timeClasses = `${classes.control} ${
    timeHasError ? classes.invalid : ""
  }`;
  const nopClasses = `${classes.control} ${
    numberOfPeopleHasError ? classes.invalid : ""
  }`;

  return (
    <form className={classes.form} onSubmit={confirmHandler}>
      <div className={classes.twoFields}>
        <div className={firstNameClasses}>
          <TextField
            required
            type="text"
            value={enteredFirstName}
            onChange={firstNameChangeHandler}
            onBlur={firstNameBlurHandler}
            id="first-name"
            label="First Name"
            sx={{
              "&": {
                width: "100%",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                "& > fieldset": {
                  borderColor: "#0094b5",
                },
              },
              "& label.Mui-focused": {
                color: "#0094b5",
              },
            }}
          />
          {firstNameHasError && (
            <p className={classes["error-text"]}>
              Please enter a valid First Name.
            </p>
          )}
        </div>

        <div className={lastNameClasses}>
          <TextField
            required
            type="text"
            value={enteredLastName}
            onChange={lastNameChangeHandler}
            onBlur={lastNameBlurHandler}
            id="last-name"
            label="Last Name"
            sx={{
              "&": {
                width: "100%",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                "& > fieldset": {
                  borderColor: "#0094b5",
                },
              },
              "& label.Mui-focused": {
                color: "#0094b5",
              },
            }}
          />
          {lastNameHasError && (
            <p className={classes["error-text"]}>
              Please enter a valid Last Name.
            </p>
          )}
        </div>
      </div>
      <div className={phoneNumberClasses}>
        <TextField
          required
          type="tel"
          value={enteredPhoneNumber}
          onChange={phoneNumberChangeHandler}
          onBlur={phoneNumberBlurHandler}
          id="phone-number"
          label="Phone Number"
          sx={{
            "&": {
              width: "100%",
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              "& > fieldset": {
                borderColor: "#0094b5",
              },
            },
            "& label.Mui-focused": {
              color: "#0094b5",
            },
          }}
        />
        {phoneNumberHasError && (
          <p className={classes["error-text"]}>
            Please enter a valid Phone Number.
          </p>
        )}
      </div>
      <div className={classes.twoFields}>
        <div className={dateClasses}>
          <TextField
            required
            id="date"
            label="Date"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            value={enteredDate}
            onChange={dateChangeHandler}
            onBlur={dateBlurHandler}
            sx={{
              "&": {
                width: "100%",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                "& > fieldset": {
                  borderColor: "#0094b5",
                },
              },
              "& label.Mui-focused": {
                color: "#0094b5",
              },
            }}
          />
          {dateHasError && (
            <p className={classes["error-text"]}>Please enter a valid Date.</p>
          )}
        </div>

        <div className={timeClasses}>
          <TextField
            required
            id="time"
            label="Time"
            type="time"
            InputLabelProps={{
              shrink: true,
            }}
            value={enteredTime}
            onChange={timeChangeHandler}
            onBlur={timeBlurHandler}
            sx={{
              "&": {
                width: "100%",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                "& > fieldset": {
                  borderColor: "#0094b5",
                },
              },
              "& label.Mui-focused": {
                color: "#0094b5",
              },
            }}
          />
          {timeHasError && (
            <p className={classes["error-text"]}>Please enter a valid Time.</p>
          )}
        </div>
      </div>
      <div className={nopClasses}>
        <TextField
          required
          id="nop"
          label="Number of People"
          type="number"
          value={enteredNumberOfPeople}
          onChange={numberOfPeopleChangeHandler}
          onBlur={numberOfPeopleBlurHandler}
          sx={{
            "&": {
              width: "100%",
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              "& > fieldset": {
                borderColor: "#0094b5",
              },
            },
            "& label.Mui-focused": {
              color: "#0094b5",
            },
          }}
        />
        {numberOfPeopleHasError && (
          <p className={classes["error-text"]}>Please enter a valid Number.</p>
        )}
      </div>
      <div className={classes.control}>
        <TextField
          id="note"
          label="Note"
          type="text"
          value={enteredNote}
          onChange={noteChangeHandler}
          onBlur={noteBlurHandler}
          multiline
          rows={5}
          sx={{
            "&": {
              width: "100%",
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              "& > fieldset": {
                borderColor: "#0094b5",
              },
            },
            "& label.Mui-focused": {
              color: "#0094b5",
            },
          }}
        />
        {noteHasError && (
          <p className={classes["error-text"]}>Please enter a valid text.</p>
        )}
      </div>
      <div className={classes.buttons}>
        <button className={classes.submit}>Book Now</button>
      </div>
    </form>
  );
};

export default BookingForm;
